import { motion } from "framer-motion";
import { Sparkles, Palette, Truck, ShieldCheck, Clock, Heart } from "lucide-react";
import { whyUs } from "../data/siteData";

const iconMap = { Sparkles, Palette, Truck, ShieldCheck, Clock, Heart };

export default function WhyUs() {
  return (
    <section
      className="py-20 md:py-28 lg:py-32 bg-white relative overflow-hidden"
      data-testid="why-us-section"
    >
      <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full bg-[#F5E9DD] blur-3xl opacity-50 pointer-events-none" />

      <div className="frida-container relative">
        <div className="text-center mb-14 lg:mb-20">
          <div className="text-xs tracking-[0.25em] uppercase text-[#A85C34] font-medium mb-3" data-testid="why-eyebrow">
            · Neden Biz ·
          </div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-[#222222] tracking-tight leading-[1.1] max-w-3xl mx-auto" data-testid="why-title">
            Premium Kalitenin <span className="italic text-[#A85C34]">Adresi</span>
          </h2>
          <p className="mt-6 text-lg text-[#555555] max-w-2xl mx-auto leading-relaxed">
            Yüzlerce mutlu müşterimizin tercih ettiği Frida Çiçekçilik ile fark yaratan altı temel söz.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {whyUs.map((item, i) => {
            const Icon = iconMap[item.icon] || Sparkles;
            return (
              <motion.div
                key={item.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="group bg-[#F8F8F8] rounded-3xl p-8 lg:p-10 lift-card border border-transparent hover:border-[#D4A15C]/30"
                data-testid={`why-card-${i}`}
              >
                <div className="w-14 h-14 rounded-full bg-white flex items-center justify-center mb-7 group-hover:bg-[#D4A15C] transition-colors duration-500">
                  <Icon className="w-6 h-6 text-[#D4A15C] group-hover:text-white transition-colors duration-500" />
                </div>
                <h3 className="font-serif text-2xl text-[#222222] tracking-tight mb-3">
                  {item.title}
                </h3>
                <p className="text-[#555555] leading-relaxed">{item.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
